<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader
  },
  data() {

    return {
      title: "Movimentos PDV",
      items: [
        {
          text: "Comercial",
          href: "/"
        },
        {
          text: "Movimentos PDV",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      exibEmit: true,
      exibDest: false,
      exibAmbos: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-pdv-list_0')
    this.atualizaDataList()
  },

  methods: {

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      //this.title = `(${this.totalPages}) Movimentos PDV: ${dtIniFormated} - ${dtFimFormated}`



      this.title = `(${e.component.totalCount()}) Movimentos PDV: ${dtIniFormated} - ${dtFimFormated}`
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov_pdv')
      console.log(this.exibEmit)

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }


      const exibEmit = this.exibEmit
      const exibDest = this.exibDest
      const exibAmbos = this.exibAmbos
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "movpdv_id",
        load: function(loadOptions){

          console.log('exibEmit')
          console.log(exibEmit)

          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'ee': exibEmit,
            'ed': exibDest,
            'ea': exibAmbos,
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/movspdv`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)


            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    novoMov(){
      console.log('novoMovPdv')
      this.$router.push(`/movpdv/editar/0`)
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      this.$router.push(`/movpdv/editar/${idData}`)
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "movpdv_status") {
          const valStatus = e.data.movpdv_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'FE':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'CA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'FE':
          return 'Fechado(FE)'
        case 'CA':
          return 'Cancelado(CA)'
      }
      return e.value
    },



  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>


        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Criar Novo Movimento"
              text="Novo Movimento"
              :on-click="novoMov"/>
        </DxItem>



      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovPdvList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />



        <DxColumn
            :width="330"
            caption="Movimentos"
            alignment="center"
            :allowHeaderFiltering="false">


          <DxColumn
              data-field="movpdv_id"
              sort-order="desc"
              caption="ID"
              data-type="number"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movpdv_status"
              caption="Status"
              alignment="center"
              data-type="text"
              :customize-text="nomeStatus"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>



          <DxColumn
              data-field="movpdv_dtemissao"
              caption="Emissão"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movpdv_codigo"
              caption="NF"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movpdv_valorliq"
              caption="Valor"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true" />


          <DxColumn
              data-field="movpdv_obs"
              caption="Obs"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true" />



        </DxColumn>


        <DxColumn
            :width="330"
            caption="Cliente"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="pecliente_nome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="pecliente_cnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="pecliente_cidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="pecliente_estado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>




        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


  </Layout>
</template>
